import {
  IntegrationCredentialsSchema,
  IntegrationMetadataSchema,
  IntegrationV2ResponseSchema,
} from "@redotech/internal-ctx-client";
import * as z from "zod";

export const updateContextualIntegration = {
  name: "updateContextualIntegration" as const,
  input: z.object({
    integrationId: z.string(),
    credentials: IntegrationCredentialsSchema.optional(),
    metadata: IntegrationMetadataSchema.optional(),
    events: z.array(z.string()).optional(),
    consentMode: z.boolean().optional(),
  }),
  output: IntegrationV2ResponseSchema,
};
